<template>
  <div>
    <ReportBuilderView
      v-if="advisor"
      :advisor="advisor"
    />
    <div v-else>
      Token auth has not finished yet
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import ReportBuilderView from '@frontend/dash3/js/views/ReportBuilderView.vue';

export default {
  name: 'ReportBuilderEmbed',
  components: { ReportBuilderView },
  props: ['advisor'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
